import { render, staticRenderFns } from "./loa.vue?vue&type=template&id=ffde0a5a&scoped=true&"
import script from "./loa.vue?vue&type=script&lang=js&"
export * from "./loa.vue?vue&type=script&lang=js&"
import style0 from "./loa.vue?vue&type=style&index=0&id=ffde0a5a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffde0a5a",
  null
  
)

export default component.exports